import $ from 'jquery'
import { dependency } from '../../utils/request';
import { directiveSettings } from '../../utils/parse';

const mapsUrl = 'https://maps.googleapis.com/maps/api/js?libraries=geometry,places&key=AIzaSyBmAhgQndyyRTTqYJVZy3JaoC7n20Fvzfw'

export default function mapDirective(context=document.body) {
    const $maps = $(context).find('[sw-map]');

    if ($maps.length > 0) {

        dependency(mapsUrl).then(function() {
            $maps.each(function() {
                const $element = $(this);
                const json = $element.attr('sw-map');
                const settings = directiveSettings(json, {
                    zoom: 15,
                    draggable: false,
                    markers: [],
                    lat: 0,
                    lng: 0,
                });

                const mapOptions = {
                    zoom: settings.zoom|0,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    center: new google.maps.LatLng(settings.lat, settings.lng),
                    scrollwheel: false,
                    streetViewControl: false,
                    draggable: settings.draggable,
                    panControl: false,
                    overviewMapControl: false,
                    zoomControl: true,
                    mapTypeControl: false,
                    disableDefaultUI: true,
                    disableDoubleClickZoom: true,
                };

                const mapElement = $element[0];
                const map = new google.maps.Map(mapElement, mapOptions);
                let markers = [];

                settings.markers.forEach(marker => {
                    markers.push(new google.maps.Marker({
                        position: new google.maps.LatLng(marker.lat, marker.lng),
                        map: map
                    }));
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/map.js